import { FC } from 'react'

import { CONTACT_TYPES } from '../constants/contact'
import { GenericContactItem } from './GenericContactItem'

type GenericContactGroupProps = {
  /**
   * Defines if the contact group should display the long form title
   */
  hasLongTitle: boolean
}

export const GenericContactGroup: FC<GenericContactGroupProps> = ({ hasLongTitle }) => {
  return (
    <>
      <GenericContactItem
        asChildOf="anchor"
        hasLongTitle={hasLongTitle}
        type={CONTACT_TYPES.PHONE}
        hasSeparator
      />

      <GenericContactItem
        asChildOf="anchor"
        hasLongTitle={hasLongTitle}
        type={CONTACT_TYPES.EMAIL}
        hasSeparator
      />

      <GenericContactItem asChildOf="button" type={CONTACT_TYPES.CHAT} />
    </>
  )
}
